<template>
  <header
    class="site-header"
    :class="{ 'open' : isOpen }"
  >
    <div class="content-max-width">

      <a href="/home" class="logo">
        <img src="/images/logo.png" alt="Website Logo" />
      </a>

      <nav>
        <ul class="top">
          <li
            v-for="(link, index) of menu"
            :key="index"
          >
            <a :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
      </nav>

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf', 'menu'
  ],

  data () {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue